var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('h3',[_vm._v("15903675013 同微信 ")]),_c('h3',[_vm._v("15903675013 同微信 ")])])}]

export { render, staticRenderFns }